import Cookies from "js-cookie";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";

// Main Private Routes Wrapper
export const PrivateRoutesStudent = () => {
  const { isAuthenticated, token } = useSelector((store) => store.studentAuth);
  const location = useLocation();

  // 🔥 fallback check from cookies (important on refresh)
  const cookieToken = Cookies.get("authToken");

  if (!isAuthenticated && !cookieToken) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default PrivateRoutesStudent;